import { Injectable } from '@angular/core';
import AbstractAuthService from './abstract-auth.service';

@Injectable()
export default class OtpAuthService extends AbstractAuthService {

  protected submitNumberEndpoint = 'otp.send';
  protected submitPasswordEndpoint = 'otp.verify';

  protected makeSubmitNumberData(): any {
    return {
      bundleNo: this.bundleNumber,
      msisdn: this.msisdn,
      processType: this.processType.toString().toUpperCase()
    };
  }

  protected makeSubmitPasswordData(password: string): any {
    return {
      bundleNo: this.bundleNumber,
      msisdn: this.msisdn,
      authCode: password
    };
  }

  protected handleSubmitNumberResponse(submitNumberResponse: string | object): void {
    if (typeof submitNumberResponse !== 'object' && Object.keys(submitNumberResponse).length !== 0) {
      this.otpPasswordForTesters = submitNumberResponse;
    }

    this.showPasswordModal();
  }

  protected handleSubmitPasswordResponse(submitPasswordResponse: any): void {
    switch (submitPasswordResponse.status) {
      case 0:
        this.resolve(submitPasswordResponse.changeMarker);
        break;
      case -1:
        this.showPasswordErrorModal();
        break;
    }
  }
}
